import { AddBox, ArrowDownward, Check, ChevronLeft, ChevronRight, Clear } from "@mui/icons-material";
import { DeleteOutline, Edit, FilterList, FirstPage, LastPage, Remove, SaveAlt } from "@mui/icons-material";
import { Search, ViewColumn } from "@mui/icons-material";
import React, { forwardRef } from "react";

export const tableIcons = {
	Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
	Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
	Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
	Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
	DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
	Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
	Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
	Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
	FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
	LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
	NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
	PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
	ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
	Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
	SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
	ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
	ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

export const defaultTableOptions = {
	pageSize: 10,
	actionsColumnIndex: -1,
	searchFieldAlignment: "left",
	searchFieldStyle: { minWidth: 580 }
};

export const dataCell = { textAlign: "center" }
export const textCell = { textAlign: "left" }
export const dataHeader = { textAlign: "center" }
export const textHeader = { textAlign: "left" }